<template>
	<div class="wrapper">
		<div class="section section-blogs-2 topsearch">
			<div class="container main">
				<div class="md-layout">
					<div class="md-layout-item md-size-100 md-small-size-100 mx-auto">
						<router-link :to="{ name: 'office', params: {dictionaryId: dictCode, page: page} }"
									 id="buttonback">
							<md-icon>keyboard_arrow_left</md-icon>
							Назад к списку Представительств
						</router-link>
					</div>
					<div class="md-layout-item md-size-100 md-small-size-100 mx-auto">

						<div class="name">
							<h3 class="title">Редактирование элемента справочника Представительств</h3>
							<div class="md-layout-item md-size-100 md-xsmall-size-100 fieldsep" v-if="selectedDataId">

								<div class="md-layout-item md-size-40 md-xsmall-size-100 text-center fieldsep">
									<md-field>
										<label>{{mapElementName['name']}}</label>
										<md-input  type="text" v-model="form['name']"/>
									</md-field>
								</div>
								<div class="md-layout-item md-size-40 md-xsmall-size-100 text-center fieldsep">
									<md-field :class="getValidationClass('phone')">
										<label>{{mapElementName['phone']}}</label>
										<md-input readonly type="text" v-if="action === 'delete'"
												  v-model.number="form['phone']"></md-input>
										<md-input type="text" v-else v-model="form['phone']"></md-input>
										<span class="md-error"
											  v-if="!$v.form.phone.required">Обязательно для заполнения</span>
									</md-field>
								</div>
							</div>
							<div class="md-layout-item md-size-40 md-xsmall-size-100 text-center fieldsep">
								<md-field :class="getValidationClass('region')">
									<label>{{ mapElementName['region'] }}</label>
									<md-select v-model="form['rehBizregionId']"
											   md-dense
											   name="rehBizregion"
											   @md-selected="changeSelBizreg()"
									>
										<md-option v-for="item of regionData" :value="item.id">{{item.name}}</md-option>
									</md-select>
								</md-field>
							</div>
							<br/>
							<div class="md-layout-item md-gutter md-size-100 md-xsmall-size-100 fieldsep">

								<template v-if="selectedDataId">
									<md-button @click="validateData(saveItem)"
											   class="md-button md-success md-theme-default"
											   v-if="action !== 'delete'">
										Сохранить
									</md-button>

									<md-button @click="validateData(deleteItem)"
											   class="md-button md-primary  md-theme-default"
											   v-if="action === 'delete'">
										Удалить
									</md-button>

								</template>
							</div>
						</div>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>
<script>
    import { validationMixin } from 'vuelidate'
    import { checkAuthentication, reAuthenticate } from '@/utils/auth-api'
    import {
        required,
    } from 'vuelidate/lib/validators'
    import { saveItem, getItem, deleteItem, saveNewItem, deleteNewItem } from '@/utils/dict-api'
	import {appConfig} from '../../utils/config-api'

    export default {
        mixins: [
            validationMixin,
        ],
        bodyClass: 'dictionary-data',
        props: ['page', 'action'],
        data () {
            return {
				regionData: null,
                options: [],
                dictCode: this.$route.params.dictCode,
                dictionaryId: '',
                selectedDataId: this.$route.params.id,
                selectedData: null,
                form: {
                	id: this.$route.params.id,
					name: '',
					phone: '',
					rehBizregion: {},
					rehBizregionId: 0,
                },
                mapElementName: {
					region: 'Выберите Бизнес-регион',
                	name: 'Название',
                    locOrder: 'Порядок отображения',
                    city: 'Город',
                    phone: 'Телефон',
                    country: 'Страна',
                    countryCode: 'Код страны',
                    fedSub: 'Федеральный субъект',
                    fedSubCode: 'Код фед субъекта',
                    cityCode: 'Код города',
                },
                cities: [],
                citiesObj: [],
            }
        },
        validations: {
            form: {
				id: {
					required,
				},
				name: {
					required,
				},
				phone: {
					required,
				},
				rehBizregion:{
					required,
				},
            },
        },
        methods: {
            setCities () {
                if (this.form.city.length > 1) {
                    fetch(`${appConfig.backendUrl}/rest/geo/getcitybyname?cityName=${this.form.city}`)
                      .then(response => {
                          return response.json()
                      })
                      .then(responseJson => {
                          this.citiesObj = responseJson
                          this.cities = []
                          responseJson.forEach(item => {
                              this.cities.push(item.city)
                          })
                      })
                } else {
                    return []
                }
            },
            getValidationClass (fieldName) {
                const field = this.$v.form[fieldName]
                if (field) {
                    return {
                        'md-invalid': field.$invalid && field.$dirty,
                    }
                }
            },
            validateData (sendFn) {
                this.$v.form.$touch()
                if (!this.$v.form.$invalid) {
                    sendFn()
                }
            },
			changeSelBizreg () {
				for (let item in this.regionData) {
					if (this.regionData[item].id == this.form.rehBizregionId) {
						this.form.rehBizregion = this.regionData[item];
					}
				}
			},
            setData: function (data) {
                this.form = data;
				this.form.rehBizregionId = this.form.rehBizregion.id;
            },
            getElementData: function () {
                if (this.selectedDataId === 'new') {
                    this.addItem()
                    return
                }
                checkAuthentication(this.$router, this.$route).then(response => {
                    getItem('office', this.selectedDataId).then(result => {
                        this.setData(result)
                    }).catch(error => {
                        reAuthenticate(this.$router, this.$route, error)
                    })
                })
            },
            addItem: function () {
                const item = {
                    id: 'new',
					name: '',
					phone: '',
					rehBizregion: {},
					rehBizregionId: 0,
                }
                this.setData(item)
            },
            saveItem: function () {
                if (this.form.id === 'new') {
                    this.form.id = null
                }
                checkAuthentication(this.$router, this.$route).then(response => {
                    saveNewItem('office', JSON.stringify(this.form)).then(result => {
                        this.$router.push({ name: 'office' })
                    }).catch(error => {
                        reAuthenticate(this.$router, this.$route, error)
                    })
                })
            },
            deleteItem: function () {
                checkAuthentication(this.$router, this.$route).then(response => {
                    deleteNewItem('office', JSON.stringify(this.form)).then(result => {
                        this.$router.push({ name: 'office' })
                    }).catch(error => {
                        reAuthenticate(this.$router, this.$route, error)
                    })
                })
            },
            checkEditableNames: function (name) {
                const editableNames = ['valueId', 'value', 'order']
                return (editableNames.indexOf(name) >= 0)
            },
			getLocation () {
				checkAuthentication(this.$router, this.$route).then(response => {
					getItem('bizregion').then(result => {
						this.regionData = result
					}).catch(error => {
						reAuthenticate(this.$router, this.$route, error)
					})
				})
			},
        },
        created () {
            if (this.$route.params.action === 'delete') {
                this.deleteItem()
            } else {
                this.getElementData()
				this.getLocation()
            }
        },
    }
</script>

<style lang="scss" scoped type="text/scss">
	.dictionary-data .md-field {
		padding-top: 16px;
		margin: 4px 0 24px;
	}

	.offset-left-16 {
		margin-left: 16px;
	}
</style>
